import { OrderAttributes } from '@albatrosdeveloper/ave-models-package';
import { DecimalPipe } from '@angular/common';
import { SalesInvoiceListCommonExportProcessor } from './sales-invoice-list-common';
import { ExportFileFormat } from 'app/layout/export-overlay';
import { DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES, MAIN_SECTION, MAIN_SECTION_LOCALIZED_PROPERTIES, SALES_INVOICE_LIST_TITLE } from './sales-invoice-list.constants';

export class SalesInvoiceListExcelExportProcessor extends SalesInvoiceListCommonExportProcessor {
  constructor(decimalPipe: DecimalPipe) {
    super(decimalPipe);
  }

  override onInit() {
    this.setSectionTitle(MAIN_SECTION, SALES_INVOICE_LIST_TITLE);
    if (this.context.format === ExportFileFormat.CSV) {
      this.setSectionOptions(MAIN_SECTION, { ignoreTitleOnOutput: true });
    }
    this.localizeItemProperties(MAIN_SECTION, MAIN_SECTION_LOCALIZED_PROPERTIES);

    this.setSectionTitle(DETAILS_SECTION, 'Detalles');
    this.localizeItemProperties(DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES);
  }

  override onAddData(item: OrderAttributes) {
    this.addToSection(MAIN_SECTION, this.transformForMainSection(item));
    this.addToSection(DETAILS_SECTION, this.transformForDetailsSection(item));
  }
}
